import emitterDataConfigApi from '@/api/config/emitterDataConfig'
import { queryKeys } from '@/constant/common'
import { APIResponseList, SearchParams } from '@/types/common'
import { Emitter } from '@/types/emitter'
import { QueryOptions, UseQueryResult, useQuery } from '@tanstack/react-query'

function useSearchEmitter(
  searchParams: SearchParams = {},
  interfaceId: number,
  queryOptions?: QueryOptions,
): UseQueryResult<APIResponseList<Emitter>, any> {
  return useQuery(
    [queryKeys.emitter, interfaceId, searchParams],
    async () => {
      const { data } = await emitterDataConfigApi.getAll({
        ...searchParams,
        interfaceId,
      })

      if (!data) return null

      // const emitterList =
      //   data.data.length > 0 &&
      //   data?.data.map((item: any) => {
      //     return {
      //       id: item.id,
      //       emitter: item.emitter,
      //       efficiency: item.efficiency,
      //       interfaceId: item.interfaceId,
      //     }
      //   })

      return {
        list: data?.data,
        page: data.page,
        size: data.size,
        sort: data.sort,
        totalCount: data.totalCount,
        totalPage: data.totalPage,
      }
    },
    queryOptions,
  )
}

export default useSearchEmitter
